export default __webpack_public_path__ + "static/media/cmsg_logo_colour.1ccf5b67.svg";